import * as Popover from '@radix-ui/react-popover';
import { HELP, type HelpId } from '../../help/topics';

/**
 * Ícone "i" ao lado de uma função ou configuração: abre um pop-up com a explicação
 * (textos em help/topics.ts). Acessível por teclado; Esc fecha.
 */
export function InfoTip({ topic, className = '' }: { topic: HelpId; className?: string }) {
  const help = HELP[topic];
  return (
    <Popover.Root>
      <Popover.Trigger
        type="button"
        aria-label={`Ajuda: ${help.title}`}
        data-help={topic}
        onClick={(e) => e.stopPropagation()}
        className={`inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border border-line-2 font-serif text-[10px] leading-none font-bold text-muted normal-case italic hover:border-amber hover:text-amber focus-visible:border-amber focus-visible:text-amber focus-visible:outline-none ${className}`}
      >
        i
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          side="bottom"
          align="start"
          sideOffset={6}
          collisionPadding={12}
          className="z-[60] w-[min(22rem,90vw)] border border-amber-line bg-panel p-3 font-sans text-[12px] leading-relaxed tracking-normal text-fg normal-case shadow-2xl"
        >
          <div className="mb-1.5 font-mono text-[11px] font-bold tracking-[0.1em] text-amber uppercase">
            {help.title}
          </div>
          {help.body.map((p, i) => (
            <p key={i} className="mt-1 first:mt-0">
              {p}
            </p>
          ))}
          <Popover.Arrow className="fill-amber-line" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
